import React from 'react'

import Base from '../_Base'

const NzM = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="12" r="12" fill="#FFEF00" />
    <path
      d="M6.27368 6.64722V17.625H8.53418V9.92209H8.56493L11.2556 17.625H13.1156L15.8066 9.84522H15.8373V17.625H18.0974V6.64722H14.6996L12.2699 14.1963H12.2392L9.67156 6.64722H6.27368Z"
      fill="black"
    />
  </Base>
)

export default NzM
